import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import App from "./pages/App";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import RealtimeTestBoard from './components/RealtimeTestBoard';
import { DrawingRoomProvider } from '@/contexts/DrawingRoomContext';
// import { TestConnection } from "@/components/TestConnection";

// Preload Excalidraw assets when the app starts
import { preloadExcalidrawAssets } from "@/utils/preloadExcalidraw";
import GoogleAnalytics from "./components/GoogleAnalytics";
preloadExcalidrawAssets();

const queryClient = new QueryClient();

const AppRouter = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <div className="min-h-screen bg-gray-50">
          {/* Google Analytics Component */}
          <GoogleAnalytics />
          
          {/* Temporary test component - we'll remove this later */}
          {/* <TestConnection /> */}
          
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/app" element={<App />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/realtime-test" element={
              <DrawingRoomProvider>
                <RealtimeTestBoard />
              </DrawingRoomProvider>
            } />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default AppRouter;
